import { Component, OnInit, Input } from '@angular/core';
import { EventsService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss']
})
export class TutorialComponent implements OnInit {

  @Input() text;
  @Input() title;
  @Input() tutorialUrl;
  @Input() eventName;
  @Input() info_3;

  showTutorial;

  constructor(
    public variablesService: VariablesService,
    private eventsService: EventsService
  ) { }

  ngOnInit() { }

  toggleTutorial(event) {
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('noscroll', event);
      this.showTutorial = event;
    }
  }

  event() {
    if (!this.eventName) { return; }
    const systemEvent = {
      eventName: this.eventName,
      info_3: this.info_3 || 'impact',
      page_name: this.variablesService.pageName
    };
    this.eventsService.sendSystemEvent(systemEvent).subscribe(_ => _);
  }
}
